import { DefaultApi, Configuration } from '@app/react/api';

const getPort = () => {
    if (window.location.port) {
        return `:${window.location.port}`;
    }
    return '';
};

export const basePath = `${window.location.protocol}//${window.location.hostname}${getPort()}`;

console.log('basePath:', basePath);

export const api = new DefaultApi(new Configuration({ basePath }));
